import * as React from 'react';
import { LoadingCircle } from 'src/App/shared/components/loading-circle.component';

export interface IDtpStepCheckingAccessProps {
}

export const DtpStepCheckingAccess = (props: IDtpStepCheckingAccessProps) => {
    return (
        <div className={'dtp-portal-card'}>
            <div className="title">
                <span>Checking access</span>
            </div>
            <div className="content">
                <LoadingCircle />
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/App/dtp-portal/cards/dtp-step-checking-access.component.tsx